import { PastillesNoyaux } from '@/components/historique/pastilles-noyaux';
import type { Traduction } from '@rosetta/shared';

interface EncadreTraductionProps {
  traduction: Pick<Traduction, 'titre' | 'texteOrigine' | 'noyaux'>;
}

/**
 * The box that says which translation the page is about: its title (or "Sans titre"), three
 * lines of the original text and the noyaux aimed at. On the waiting screen W1 (#7), and on a
 * failed translation shown at the address of its result (#13).
 */
export function EncadreTraduction({ traduction }: EncadreTraductionProps) {
  const { titre, texteOrigine, noyaux } = traduction;
  return (
    <section
      aria-label="traduction demandée"
      className="mt-8 flex flex-col gap-3 rounded-md border border-gray-200 px-6 py-6"
    >
      {titre === undefined ? (
        <span className="font-semibold text-h4 text-gray-600 italic leading-[1.35]">
          Sans titre
        </span>
      ) : (
        <span className="break-words font-semibold text-h4 leading-[1.35]">{titre}</span>
      )}
      <span className="line-clamp-3 font-light text-body text-gray-700 leading-[1.55]">
        {texteOrigine}
      </span>
      <div className="flex flex-wrap items-center gap-2 text-gray-700 text-small">
        vers
        <PastillesNoyaux noyaux={noyaux} />
      </div>
    </section>
  );
}
